import { Typography, Box } from '@mui/material';
import { Liscense } from './liscense';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
    wrapper: {
        [theme.breakpoints.up('sm')]: {
            ustifyContent: 'space-between',
            display: 'flex',
            marginLeft: 88,
            paddingRight: 10,
            marginTop: 10,
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            paddingRight: 0,
            marginTop: 0,
            textAlign: 'center',
            flexDirection: 'column',
        },
    },
}));

export const Copyright = () => {
    const classes = useStyles();
    return (
        <Box className={classes.wrapper}>
            {/* <Liscense /> */}
            {/* <Typography sx={styles.copyright}>
                &#169; Total Automation Solutions - 2022-23
            </Typography> */}
        </Box>
    );
};

const styles = {
    copyright: {
        textAlign: 'center',
    },
};
